import React, { FunctionComponent } from "react";
import { Box, Card, DialogContent, Toolbar, useTheme } from "@mui/material";
import { strings } from "../../../localization/LocalizedStrings";
import { ToolbarButton } from "../../toolbar/ToolbarButton";
import { IShelfSegment } from "../../../hooks/shelfSegments";
import { PiperDialog } from "../../PiperDialog";
import { IconType } from "../../../icons";
import styles from "../../stats/StatsDetail/styles.module.scss";
import { RightDetailListItem } from "../../RightDetailListItem";
import { IShelf } from "../../../hooks/shelves";
import { IShelving } from "../../../hooks/shelvings";
import { useShelvingStats } from "../../../hooks/shelvings/useShelvingStats";
import { PiperDivider } from "../../PiperDivider";

export const ShelfSegmentStatsDialog: FunctionComponent<IShelfSegmentStatsDialogProps> = ({
  open,
  setOpen,
  shelfSegment,
  shelf,
  shelving
}) => {
  const theme = useTheme();
  const { shelvingAlbumCount, shelfAlbumCount, shelfSegmentAlbumCount } = useShelvingStats();
  return (
    <PiperDialog fullWidth maxWidth={"sm"} open={open} onClose={() => setOpen(false)}>
      <Toolbar>
        <h3>{strings.option_stats}</h3>
        <Box sx={{ flexGrow: 1 }} />
        <ToolbarButton
          onClick={() => setOpen(false)}
          tooltip={strings.close}
          iconType={IconType.Close}
        />
      </Toolbar>
      <DialogContent sx={{ paddingTop: 0, paddingBottom: 0 }}>
        <Card
          elevation={5}
          className={styles.itemCard}
          style={{ backgroundColor: theme.palette.background.default }}
        >
          {shelving && (
            <RightDetailListItem
              title={strings.shelving_albums_stats_title}
              detail={shelvingAlbumCount(shelving)}
            />
          )}
          {shelf && (
            <>
              <PiperDivider />
              <RightDetailListItem
                title={strings.shelf_albums_stats_title}
                detail={shelfAlbumCount(shelf)}
              />
            </>
          )}
          {shelfSegment && (
            <>
              <PiperDivider />
              <RightDetailListItem
                title={strings.shelf_segment_albums_stats_title}
                detail={shelfSegmentAlbumCount(shelfSegment)}
              />
            </>
          )}
        </Card>
      </DialogContent>
    </PiperDialog>
  );
};

export interface IShelfSegmentStatsDialogProps {
  open: boolean;
  setOpen: (state: boolean) => void;
  shelfSegment?: IShelfSegment;
  shelf?: IShelf;
  shelving?: IShelving;
}
